/* eslint-disable @nx/enforce-module-boundaries */
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesValues } from '../../../common/enums/routes.enum';
import { UserRolesPermissionsService } from '@socium/sociumflow';
import {
  DOC_COUNTRY_CONFIGURATIONS_CREATE,
  DOC_COUNTRY_CONFIGURATIONS_UPDATE,
} from '@socium/common-api';

export const SOCIUM_ADMIN_GUARD = () => {
  const userRolesPermissionsService = inject(UserRolesPermissionsService);
  const router = inject(Router);
  if (
    userRolesPermissionsService.hasSociumManagementAccess([
      DOC_COUNTRY_CONFIGURATIONS_CREATE,
      DOC_COUNTRY_CONFIGURATIONS_UPDATE,
    ])
  )
    return true;
  router.navigate([RoutesValues.FORBIDDEN]);
  return false;
};
